import { render, staticRenderFns } from "./TmSessionWelcome.vue?vue&type=template&id=939e22b4&scoped=true&"
import script from "./TmSessionWelcome.vue?vue&type=script&lang=js&"
export * from "./TmSessionWelcome.vue?vue&type=script&lang=js&"
import style0 from "./TmSessionWelcome.vue?vue&type=style&index=0&id=939e22b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939e22b4",
  null
  
)

export default component.exports